<section>
  <div class="container py-16 flex flex-col gap-12">
    <div>
      <h1 class="text-2xl md:text-3xl font-semibold mb-2.5">{{ 'PAGES.PRIVACY.TITLE' | translate }}</h1>
      <div class="italic text-gray-500 text-sm">{{ 'PAGES.PRIVACY.LAST_UPDATE' | translate:{date: (lastUpdateDate |
        date)} }}
      </div>
    </div>
    <div class="flex flex-col gap-10 md:gap-14 lg:gap-24 md:flex-row-reverse">
      <div class="shrink-0 h-max md:sticky md:top-28 md:max-w-sm">
        <h3 class="text-lg mb-2">{{ 'PAGES.PRIVACY.CONTENTS' | translate }}</h3>
        <ol class="font-medium flex flex-col gap-2.5">
          <li class="underline"><a [routerLink]="['/privacy']" [fragment]="'preamble'">{{ 'PAGES.PRIVACY.PREAMBLE_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/privacy']" [fragment]="'principles'">{{ 'PAGES.PRIVACY.PRINCIPLES_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/privacy']" [fragment]="'data'">{{ 'PAGES.PRIVACY.DATA_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/privacy']" [fragment]="'controller'">{{ 'PAGES.PRIVACY.CONTROLLER_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/privacy']" [fragment]="'rights'">{{ 'PAGES.PRIVACY.RIGHTS_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/privacy']" [fragment]="'cookies'">{{ 'PAGES.PRIVACY.COOKIES_TITLE' | translate }}</a></li>
          <li class="underline"><a [routerLink]="['/privacy']" [fragment]="'modification'">{{ 'PAGES.PRIVACY.MODIFICATION_TITLE' | translate }}</a></li>
        </ol>
      </div>
      <div class="flex flex-col gap-8">
        <div class="scroll-mt-28" id="preamble">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.PRIVACY.PREAMBLE_TITLE' | translate }}</h3>
          <p class="mb-1.5">{{ 'PAGES.PRIVACY.PREAMBLE_INTRO' | translate }}</p>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.PREAMBLE_LIST' | translate); track $index) {
            <li [innerHTML]="item"></li>
            }
          </ul>
        </div>
        <div class="scroll-mt-28" id="principles">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.PRIVACY.PRINCIPLES_TITLE' | translate }}</h3>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.PRINCIPLES_LIST' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          <div class="mt-4">
            <div class="mb-2">{{ 'PAGES.PRIVACY.LAWFULNESS_TITLE' | translate }}</div>
            <ul class="list-disc pl-7 flex flex-col gap-1.5">
              @for (item of ('PAGES.PRIVACY.LAWFULNESS_LIST' | translate); track $index) {
              <li>{{ item }}</li>
              }
            </ul>
          </div>
        </div>
        <div class="scroll-mt-28" id="data">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.PRIVACY.DATA_TITLE' | translate }}</h3>
          <div class="mb-2">{{ 'PAGES.PRIVACY.DATA_COLLECTED_TITLE' | translate }}</div>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.DATA_COLLECTED_LIST' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          <div class="mt-4 mb-2">{{ 'PAGES.PRIVACY.DATA_PURPOSE_TITLE' | translate }}</div>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.DATA_PURPOSE_LIST' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          <div class="mt-4 mb-2">{{ 'PAGES.PRIVACY.DATA_COLLECTION_MODE_TITLE' | translate }}</div>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.DATA_COLLECTION_MODE_LIST' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          <div class="mt-4 mb-2">{{ 'PAGES.PRIVACY.DATA_RETENTION_TITLE' | translate }}</div>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.DATA_RETENTION_LIST' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          <div class="mt-4 mb-2">{{ 'PAGES.PRIVACY.DATA_HOSTING_TITLE' | translate }}</div>
          <p>{{ 'PAGES.PRIVACY.DATA_HOSTING' | translate }}</p>
        </div>
        <div class="scroll-mt-28" id="controller">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.PRIVACY.CONTROLLER_TITLE' | translate }}</h3>
          <div class="mb-2">{{ 'PAGES.PRIVACY.CONTROLLER_RESPONSIBLE_TITLE' | translate }}</div>
          <p>{{ 'PAGES.PRIVACY.CONTROLLER_RESPONSIBLE' | translate }}</p>
          <div class="mt-4 mb-2">{{ 'PAGES.PRIVACY.CONTROLLER_DPO_TITLE' | translate }}</div>
          <p>{{ 'PAGES.PRIVACY.CONTROLLER_DPO' | translate }}</p>
        </div>
        <div class="scroll-mt-28" id="rights">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.PRIVACY.RIGHTS_TITLE' | translate }}</h3>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.RIGHTS_LIST' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          <p class="mt-4">{{ 'PAGES.PRIVACY.RIGHTS_EXERCISE' | translate }}</p>
        </div>
        <div class="scroll-mt-28" id="cookies">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.PRIVACY.COOKIES_TITLE' | translate }}</h3>
          <ul class="list-disc pl-7 flex flex-col gap-1.5">
            @for (item of ('PAGES.PRIVACY.COOKIES_LIST' | translate); track $index) {
            <li>{{ item }}</li>
            }
          </ul>
          <p class="mt-4">{{ 'PAGES.PRIVACY.COOKIES_BANNER' | translate }}</p>
        </div>
        <div class="scroll-mt-28" id="modification">
          <h3 class="text-xl md:text-2xl mb-3">{{ 'PAGES.PRIVACY.MODIFICATION_TITLE' | translate }}</h3>
          <p>{{ 'PAGES.PRIVACY.MODIFICATION' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>